// extracted by mini-css-extract-plugin
module.exports =  {"plate":"_7506d987b5--plate--qqiVS","content":"_7506d987b5--content--CTnGV","link":"_7506d987b5--link--CDRZR"};